(() => {
  const init = (root) => {
    if (!root || root.dataset.scenarioReady === 'true') return;
    root.dataset.scenarioReady = 'true';

    const tabs = [...root.querySelectorAll('[data-stage-tab]')];
    const stagePanels = [...root.querySelectorAll('[data-stage-panel]')];
    const detailPanels = [...root.querySelectorAll('[data-detail-panel]')];
    const jumpLinks = [...root.querySelectorAll('[data-scenario-jump]')];
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setActive = (key, focusTab = false) => {
      const nextTab = tabs.find((tab) => tab.dataset.stageTab === key);
      const nextStage = stagePanels.find((panel) => panel.dataset.stagePanel === key);
      const nextDetail = detailPanels.find((panel) => panel.dataset.detailPanel === key);
      if (!nextTab || !nextStage || !nextDetail) return false;

      tabs.forEach((tab) => {
        const active = tab === nextTab;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      stagePanels.forEach((panel) => {
        const active = panel === nextStage;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      detailPanels.forEach((panel) => {
        const active = panel === nextDetail;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      const rail = nextTab.parentElement;
      if (rail && rail.scrollWidth > rail.clientWidth) {
        rail.scrollTo({
          left: nextTab.offsetLeft - ((rail.clientWidth - nextTab.offsetWidth) / 2),
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }
      if (focusTab) nextTab.focus();
      return true;
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => setActive(tab.dataset.stageTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else nextIndex = (index + 1) % tabs.length;
        setActive(tabs[nextIndex].dataset.stageTab, true);
      });
    });

    jumpLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const key = link.dataset.scenarioJump;
        if (!setActive(key)) return;
        event.preventDefault();
        requestAnimationFrame(() => root.querySelector(`#explore-${CSS.escape(key)}`)?.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' }));
        if (window.history?.replaceState) window.history.replaceState(null, '', `#explore-${key}`);
      });
    });

    const activateHash = () => {
      const key = window.location.hash.replace(/^#(?:explore-)?/, '');
      if (key) setActive(key);
    };
    activateHash();
    window.addEventListener('hashchange', activateHash);

    const dialog = root.querySelector('[data-scenario-dialog]');
    const openButtons = [...root.querySelectorAll('[data-video-open]')];
    const videoPanels = dialog ? [...dialog.querySelectorAll('[data-video-panel]')] : [];
    const closeButton = dialog?.querySelector('[data-video-close]');
    let returnFocus = null;

    const stopVideos = () => videoPanels.forEach((panel) => {
      const video = panel.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    const closeDialog = () => {
      if (!dialog) return;
      stopVideos();
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      returnFocus?.focus();
      returnFocus = null;
    };

    const openDialog = (key, trigger) => {
      if (!dialog) return;
      const panel = videoPanels.find((item) => item.dataset.videoPanel === key);
      if (!panel) return;
      returnFocus = trigger;
      videoPanels.forEach((item) => { item.hidden = item !== panel; });
      const video = panel.querySelector('video');
      if (video && video.dataset.loaded !== 'true') {
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.dataset.loaded = 'true';
        video.load();
      }
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      video?.play().catch(() => {});
    };

    openButtons.forEach((button) => button.addEventListener('click', () => openDialog(button.dataset.videoOpen, button)));
    closeButton?.addEventListener('click', closeDialog);
    dialog?.addEventListener('close', stopVideos);
    dialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
  };

  document.querySelectorAll('[data-scenario-page]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-scenario-page]')));
})();

